module.exports = __webpack_public_path__ + "resources/img/main_banner_gov05_m.5b58a403744f580282fef9849ad4e9c9.png";